import {gql, useSubscription} from "@apollo/client";
import React, {useContext, useEffect} from "react";
import {getChannelCallState} from "./types/getChannelCallState";
import {getAccessToken, GlobalContext} from "../../../state/GlobalProvider";
import {throttle} from "../../../util/throttle";

const EVENT_SUBSCRIPTION = gql`
    subscription getChannelCallState {
        onChannelCallStateChange {
            event
            channelId
            channelCallState
            callDirection
            channelPresenceId
            callerIdName
            callerIdNumber
            calleeIdName
            calleeIdNumber
            callerDestinationNumber
        }
    }`

export default function ChannelStateEvent(props: { dispatch: React.Dispatch<any>, children: React.ReactNode }) {
    const { dispatch } = props;

    useSubscription<getChannelCallState>(
        EVENT_SUBSCRIPTION,
        {
            onData: ({ data }) => {
                if (data.data?.onChannelCallStateChange) {
                    dispatch({ type: 'CALL_STATE', data: data.data.onChannelCallStateChange });
                }
            },
        }
    );

    return <>{props.children}</>

}
